module.exports = __webpack_public_path__ + "static/media/XRP-icon.a08968f9.svg";